import Box from "@material-ui/core/Box";
import React from "react";
import {makeStyles} from "@material-ui/core";

const CircleIconWithDot = () => {
  const classes = useStyles();
  return (
    <Box className={classes.parentIcon}>
      <Box className={classes.innerIcon} />
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  parentIcon: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: "rgba(30, 136, 229, 0.2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  innerIcon: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default CircleIconWithDot;
